import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress benign ResizeObserver errors (common with UI component animations)
// This error is harmless and occurs during dropdown/select animations
// Must run BEFORE React mounts to catch errors in the error overlay
if (typeof window !== 'undefined') {
  // Patch ResizeObserver to prevent the error from being thrown
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        // Use requestAnimationFrame to batch resize observations
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };

  // Suppress any ResizeObserver errors that slip through
  const errorHandler = (e) => {
    if (e && e.message && e.message.includes('ResizeObserver loop')) {
      e.stopImmediatePropagation();
      e.stopPropagation();
      e.preventDefault();
      return true;
    }
  };
  
  window.addEventListener('error', errorHandler, true);
  window.addEventListener('unhandledrejection', (e) => {
    if (e.reason && e.reason.message && e.reason.message.includes('ResizeObserver')) {
      e.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
